import React from 'react'
import { useTranslation } from 'react-i18next'

import { AccessDeniedPage } from 'views/AccessDeniedPage/AccessDeniedPage'

export const PaymentsAccessDeniedPage: React.FC = () => {
  const { t } = useTranslation(['payments'])

  return (
    <AccessDeniedPage message={t('payments:errors.paymentsAccessDenied')} />
  )
}
